import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import CCColorPicker from "../../components/common/CCColorPicker";
import { addEventNameToEndpoint } from "../../utils/common";
import "./AddContentItemForm.scss";

class AddContentTagForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      contentTag: '',
      sort: 1,
      color: '#ff0000',
      description: ''
    }
  }

  componentDidMount() {
    if (this.props.contentTag) {
      this.setState({
        contentTag: this.props.contentTagName,
        sort: this.props.contentTag.sort,
        description: this.props.contentTag.description,
        color: this.props.contentTag.color || '#ff0000',
        isEditing: true
      });
    }
  }

  onChangeValue = (type, value) => {
    this.setState({ [type]: value });
  }

  onSubmit = (e) => {
    e.preventDefault();

    addEventNameToEndpoint(this.props.Analytics, 'admin-tag-edit');

    this.props.onAddContentTag({
      originalName: this.state.isEditing ? this.props.contentTagName : null,
      name: this.state.contentTag,
      sort: this.state.sort,
      description: this.state.description,
      color: this.state.color
    });

    this.props.onClose();
  }

  render() {
    const {
      contentTag,
      sort,
      description,
      isEditing,
      color
    } = this.state;

    return (
      <Form className="add-content-item-form" onSubmit={this.onSubmit}>
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="p-4">
          <h3>{isEditing ? "Edit Content Tag" : "Add Content Tag"}</h3>
          <Form.Group as={Row} controlId="contentTagName">
            <Col sm="6">
              <Form.Control
                type="text"
                className="mr-4"
                placeholder="Content tag name"
                value={contentTag}
                onChange={(e) => this.onChangeValue('contentTag', e.target.value)}
                required
              />
            </Col>
            <Col sm="3">
              <Form.Control
                type="text"
                placeholder="Sort"
                value={sort}
                onChange={(e) => this.onChangeValue('sort', e.target.value)}
                required
              />
            </Col>
            <Col sm="3">
              <CCColorPicker value={color} onChange={(hexColor) => this.onChangeValue('color', hexColor)} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="contentTagDescription">
            <Col sm="12">
              <Form.Control
                as="textarea"
                rows="4"
                placeholder="Description..."
                value={description}
                onChange={(e) => this.onChangeValue('description', e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="actionsContainer" >
            <Col className="d-flex justify-content-end actions-container">
              <Button variant="outline-danger" className="mr-2" size="sm" onClick={this.props.onClose}>CANCEL</Button>
              <Button
                type="submit"
                variant="outline-danger"
                size="sm"
                data-cc-analytics-on='click'
                id="btnEditContentTag"
                data-cc-analytics-name='admin-tag-edit'
                data-cc-analytics-attrs={`contentTagName:${contentTag}`}
              >
                SAVE
              </Button>
            </Col>
          </Form.Group>
        </div>
      </Form>
    )
  }
}

export default AddContentTagForm;
